import React from 'react'
import api from 'api'
import {useSelector} from 'react-redux'
import {useHistory} from 'react-router-dom'
import EmployeesList from 'procedures/EmployeesList'

const ChooseEmployee = () => {
  const history = useHistory()
  const token = useSelector((state) => state.auth.token)
  const selectEmployee = (employeeId) => {
    api
      .createWithAuth(token)
      .procedureStatuses.list({procedure_type: 'start_maternity', employee_id: employeeId}, [
        'employee',
        'procedure_maternity_datum',
      ])
      .then(({data}) => {
        if (data.length > 0) {
          history.push(`/extend_maternity/choose_use_or_create?employee_id=${employeeId}`)
        } else {
          history.push(`/extend_maternity/detail?employee_id=${employeeId}`)
        }
      })
  }
  const searchFormQueryConverter = (query) => ({
    ...query,
    _added_fields: [...query._added_fields, 'genders'],
    genders: ['woman'],
  })
  return (
    <div>
      <div className="l-title-wrap">
        <h1 className="m-title-main">従業員を選択してください</h1>
      </div>
      <div className="l-wrap-xl">
        <EmployeesList
          handleClick={(employeeId) => {
            selectEmployee(employeeId)
          }}
          searchFormAddedFieldHideValues={['genders']}
          searchFormQueryConverter={searchFormQueryConverter}
        />
      </div>
    </div>
  )
}

export default ChooseEmployee
